import { CommonModule } from '@angular/common';
import { Component, ViewContainerRef } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { DigitOnlyModule } from '@uiowa/digit-only';
import { AuxiliaryDataFieldSchemaInterface, AuxiliaryDataSearchIntegerOperation } from '@vendasta/account-group';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { AuxiliaryDataSearchInfoInterface, FilterHandler } from '../auxiliary-data-accounts-table-filters.service';

export class IntegerFilterHandler implements FilterHandler {
  formControl: FormControl;
  schema: AuxiliaryDataFieldSchemaInterface;
  //validators: FieldHandlerValidator[] = [];
  formControlEndRange: FormControl;

  constructor(public fieldSchema: AuxiliaryDataFieldSchemaInterface) {
    this.formControl = new FormControl();
    this.formControlEndRange = new FormControl();
    this.formControl.setValidators([]);
    this.schema = fieldSchema;
  }

  render(viewContainerRef: ViewContainerRef): void {
    viewContainerRef.clear();
    const component = viewContainerRef.createComponent<IntegerFilterRendererComponent>(IntegerFilterRendererComponent);
    component.instance.controlFrom = this.formControl;
    component.instance.controlTo = this.formControlEndRange;
    //component.instance.validators = [];
    component.instance.readOnly = false;
  }
  filterOperation(operation: AuxiliaryDataSearchIntegerOperation): AuxiliaryDataSearchInfoInterface {
    return {
      filter: {
        fieldId: this.schema?.fieldId,
        filterRange: {
          beginRange: this.formControl?.value.toString() || '',
          endRange: this.formControlEndRange?.value.toString() || '',
        },
        operation: { integerOperation: operation },
      },
      fieldName: this.schema?.fieldName,
      filterValue: 'from ' + this.formControl?.value?.toString() + ' to ' + this.formControlEndRange?.value?.toString(),
      operationName: '',
    };
  }

  hasModification(): boolean {
    return this.formControl.dirty;
  }
}

@Component({
  standalone: true,
  styles: [
    ':host, mat-form-field, input {width: 100%}',
    `
      :host ::ng-deep .mat-form-field-appearance-outline .mat-form-field-flex {
        margin-top: 0;
      }
    `,
    ':host #integerFrom {margin: 0 5px; padding: 6px 0 8px;}',
    ':host #integerFrom ::ng-deep .input-and-hints {margin:0;}',
  ],
  template: `
    <glxy-form-field [size]="'large'" id="integerFrom">
      <glxy-label>From</glxy-label>
      <input
        matInput
        [formControl]="controlFrom"
        type="number"
        inputmode="numeric"
        pattern="[0-9-]*"
        digitOnly
        [allowNegatives]="true"
      />
    </glxy-form-field>
    <glxy-form-field [size]="'large'" id="integerTo">
      <glxy-label>To</glxy-label>
      <input
        matInput
        [formControl]="controlTo"
        type="number"
        inputmode="numeric"
        pattern="[0-9-]*"
        digitOnly
        [allowNegatives]="true"
      />
    </glxy-form-field>
  `,
  imports: [CommonModule, MatInputModule, ReactiveFormsModule, DigitOnlyModule, TranslateModule, GalaxyFormFieldModule],
})
export class IntegerFilterRendererComponent {
  controlFrom!: FormControl;
  controlTo!: FormControl;
  readOnly!: boolean;
}
